import ShoePicker from "./ShoePicker.component";

export default ShoePicker;
